module.exports = __webpack_public_path__ + "img/logo-ct.96f74974.png";